import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const NumberIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m9.447 13.578.926-3.156h4.18l-.926 3.156h-4.18ZM7.03 15.353l-1.22 4.16L7.563 20l1.363-4.647h4.18l-1.22 4.16 1.753.487 1.363-4.647h4.112v-1.775h-3.591l.926-3.156H20V8.647h-3.03l1.22-4.16L16.437 4l-1.363 4.647h-4.18l1.22-4.16L10.361 4 8.998 8.647H4.886v1.775h3.591l-.926 3.156H4v1.775h3.031Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m9.447 13.578.926-3.156h4.18l-.926 3.156h-4.18ZM7.03 15.353l-1.22 4.16L7.563 20l1.363-4.647h4.18l-1.22 4.16 1.753.487 1.363-4.647h4.112v-1.775h-3.591l.926-3.156H20V8.647h-3.03l1.22-4.16L16.437 4l-1.363 4.647h-4.18l1.22-4.16L10.361 4 8.998 8.647H4.886v1.775h3.591l-.926 3.156H4v1.775h3.031Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `NumberIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { NumberIcon };
//# sourceMappingURL=NumberIcon.mjs.map
